export const isLocaleSupported = (locale: string) =>
  Intl.NumberFormat.supportedLocalesOf([locale]).length > 0;

export const getUserLocale = () =>
  Intl.DateTimeFormat().resolvedOptions().locale;
